import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { PosService } from "src/app/_services/posService";
import { InvoiceService } from "./../../../../_services/invoice.service";

@Component({
  selector: "app-upload-credit-note",
  templateUrl: "./upload-credit-note.component.html",
  styleUrls: ["./upload-credit-note.component.scss"],
})
export class UploadCreditNoteComponent implements OnInit {
  invoiceTypes = [
    { label: "IRN e-invoice", type: "e-invoice" },
    { label: "Digitally Signed e-invoice", type: "ds-invoice" },
  ];
  noteTypes = [
    { label: "Credit Note", type: "CN" },
    { label: "Debit Note", type: "DN" },
  ];
  supportingDocuments: any[] = [];
  loading = false;
  fileTypeError = false;
  fileSizeError = false;
  signatureError = false;
  qrCodeError = false;
  validateSignature = false;
  validateEinvoice = false;
  validateEinvoiceResubmit = false;
  responseData: any;
  poResponseData: any;
  displayName: any;
  message: any;
  poItems = [];
  fileName: string = "";
  poNo: any;
  poType;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  dsLoaderMsg = "";
  eLoaderMsg = "";
  eLoaderMsgResubmit = "";
  timeoutID;
  formSubmitted = false;
  previousUrl: any;
  totalSizeError;
  files: File[];
  companyCode;
  purchaseOrg;
  docType;
  intialLoading = false;
  invList;
  isPoInvoice = false;
  isService = false;

  creditNoteData = new FormGroup({
    invoiceType: new FormControl(null, [Validators.required]),
    noteType: new FormControl(null, [Validators.required]),
    file: new FormControl(null),
    fileSource: new FormControl(null, [Validators.required]),
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private poService: PosService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectCreditNote(event: any) {
    this.invoiceService.setFileElement(event[0]);

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

    if (event.length > 0) {
      const fileUploaded = event[0];
      if (fileUploaded.type !== "application/pdf") {
        this.fileTypeError = true;
      } else if (fileUploaded.size > MAX_FILE_SIZE) {
        this.fileSizeError = true;
      } else {
        this.creditNoteData.patchValue({
          fileSource: fileUploaded,
        });
      }
    }

    this.fileName = event[0].name;
  }

  extrationMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsg = msg;
    }, time);
  }

  extrationResubmitMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsgResubmit = msg;
    }, time);
  }

  closeFileErrorDialog() {
    this.loading = false;
    this.fileTypeError = false;
    this.qrCodeError = false;
  }

  closeSignatureErrorDialog() {
    this.loading = false;
    this.signatureError = false;
  }

  fetchPoItems(poNo, poType) {
    this.intialLoading = true;
    if (poType === "SERV" || this.isService) {
      const userData = {
        poNo: poNo,
        action: "get",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (this.poResponseData.status == "successful") {
            this.companyCode = this.poResponseData.pos[0].po_company_code;
            this.purchaseOrg = this.poResponseData.pos[0].po_purchase_org;
            this.docType = this.poResponseData.pos[0].po_doc_type;

            this.poResponseData.pos[0].line_items.forEach((p: any) => {
              this.poItems.push({
                poNo: poNo,
                itemNo: p.po_item_line,
                grn: "",
                barcode: "",
              });
            });
            this.intialLoading = false;
          } else {
            console.log("error");
            this.intialLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.intialLoading = false;
        }
      );
    } else {
      const userData = {
        poNo: poNo,
        action: "list",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (this.poResponseData.status == "successful") {
            this.companyCode = this.poResponseData.pods[0].po_company_code;
            this.purchaseOrg = this.poResponseData.pods[0].po_purchase_org;
            this.docType = this.poResponseData.pods[0].po_doc_type;

            this.poResponseData.pods.forEach((p: any) => {
              this.poItems.push({
                poNo: p.po_no,
                itemNo: p.po_item_line,
                grn: p._id,
                barcode: "",
              });
            });
            this.intialLoading = false;
          } else {
            console.log("error");
            this.intialLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.intialLoading = false;
        }
      );
    }
  }

  onCNsubmit() {
    this.loading = true;
    this.formSubmitted = true;
    this.qrCodeError = false;
    this.signatureError = false;

    this.invoiceService.setDocuments(this.supportingDocuments);

    // Get current user session for digital signature verification
    const currentUser = this.authService.getCurrentUser();
    const session = currentUser?.eippSessionData?.data?.session;

    // Create ledger array similar to invoice submission
    const ledger: any[] = [];

    const pods: any = localStorage.getItem("pods");
    const convertPods = JSON.parse(pods);
    console.log(convertPods, "convertPods");

    if (localStorage.getItem("selectionType") === "po") {
      console.log(localStorage.getItem("selectionType"), "selectionType");

      // PO-based credit note
      convertPods.forEach((pod: any) => {
        this.loading;
        const ledgerEntry = {
          docType: this.docType || "CN",
          docDetail: {
            docFormat: this.creditNoteData.value.invoiceType === "e-invoice" ? "e-invoice" : "ds-invoice",
            docCat: "po_based",
          },
          cmpCode: pod.cmpCode || undefined,
          purchaseOrg: pod.purchaseOrg || undefined,
          erpDocType: pod.erpDocType || undefined,
        };
        ledger.push(ledgerEntry);
      });
    } else {
      // Non-PO based credit note
      convertPods.forEach((pod: any) => {
        const ledgerEntry = {
          docType: this.creditNoteData.value.noteType || "CN",
          docDetail: {
            docFormat: this.creditNoteData.value.invoiceType === "e-invoice" ? "e-invoice" : "ds-invoice",
            docCat: localStorage.getItem("invoiceType") === "nonPoInvoice" ? "non_po_based" : "inv_based",
          },
          cmpCode: pod.cmpCode || undefined,
          purchaseOrg: pod.purchaseOrg || undefined,
          erpDocType: pod.erpDocType || undefined,
        };
        ledger.push(ledgerEntry);
      });
    }

    console.log("Ledger array created:", ledger);

    // Create items array similar to invoice submission
    const items: any[] = [];
    if (localStorage.getItem("selectionType") === "po") {
      this.poItems.forEach((item) => {
        items.push({
          poNo: item.poNo,
          itemNo: item.itemNo,
          grn: item.grn,
        });
      });
    } else {
      this.invList.forEach((invoice) => {
        let po = invoice.poNo === null ? "" : invoice.poNo;
        items.push({
          poNo: po,
          itemNo: "",
          grn: "",
        });
      });
    }

    // Create user data structure similar to invoice submission
    const userData = {
      req: {
        companyCode: localStorage.getItem("selectionType") === "po" ? this.companyCode : "",
        purchaseOrg: localStorage.getItem("selectionType") === "po" ? this.purchaseOrg : "",
        docType: localStorage.getItem("selectionType") === "po" ? this.docType : this.creditNoteData.value.noteType,
        items: items,
      },
    };

    localStorage.setItem("req", JSON.stringify(userData.req));

    if (this.creditNoteData.value.invoiceType === "e-invoice") {
      this.validateEinvoice = true;
      if (this.isPoInvoice) {
        this.invoiceService.setInvoiceType("po_based");
      } else {
        this.invoiceService.setInvoiceType("non_po_based");
      }
      this.invoiceService.setInvType("e-invoice");

      this.invoiceService.setNoteType(this.creditNoteData.value.noteType);

      const formData: any = new FormData();
      if (localStorage.getItem("selectionType") === "po") {
        formData.append("docNo", this.route.snapshot.params["poNo"] || "");
      }
      // formData.append("docNo", this.route.snapshot.params["poNo"] || "");
      formData.append("sellerCode", localStorage.getItem("sellerCode") || localStorage.getItem("vendorCode"));
      formData.append("supplierCode", localStorage.getItem("vendorCode"));
      formData.append("ledger", JSON.stringify(ledger));
      formData.append("invoiceFile", this.creditNoteData.value.fileSource);
      formData.append("extractionVersion", "1");

      console.log(formData, "formData");

      if (this.creditNoteData.value.noteType === "CN") {
        localStorage.setItem("document", "Credit Note");
      } else {
        localStorage.setItem("document", "Debit Note");
      }

      this.eLoaderMsg = "Verifying QR Code";
      this.extrationMessages("Authenticating QR Code", 5000);
      this.extrationMessages("Extracting Data", 10000);
      this.extrationMessages("Validating Data", 15000);

      // Add timestamp for better tracking
      const eInvoiceTimestamp = Date.now();

      this.invoiceService.extractInvoice(formData).subscribe(
        (res) => {
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = res;
          clearTimeout(this.timeoutID);

          if (this.responseData.length !== 0 && this.responseData.status === "error") {
            console.log("error");
            //console.log(this.responseData);

            //this.qrCodeError = true;

            //this.message = this.responseData.msg;

            if (this.responseData.msg.includes("unreadable")) {
              this.loading = true;
              this.validateEinvoiceResubmit = true;

              this.eLoaderMsgResubmit = "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

              formData.set("extractionVersion", "2");
              //this.eLoaderMsg = "Authenticating QR Code";

              this.extrationResubmitMessages("Verifying QR Code", 5000);
              this.extrationResubmitMessages("Authenticating QR Code", 10000);
              this.extrationResubmitMessages("Extracting Data", 15000);
              this.extrationResubmitMessages("Validating Data", 20000);

              setTimeout(() => {
                this.invoiceService.extractInvoice(formData).subscribe(
                  (res) => {
                    this.responseData = res;

                    if (this.responseData.length !== 0 && this.responseData.status === "error") {
                      this.validateEinvoiceResubmit = false;
                      this.qrCodeError = true;
                      this.message = this.responseData.msg;
                    } else {
                      console.log("Success - E-invoice resubmit extracted:", this.responseData);
                      this.qrCodeError = false;
                      this.poNo = this.route.snapshot.params["poNo"];
                      const processedInvoice = {
                        file_link: this.responseData.data.meta.src,
                        supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
                        invoice_number: this.responseData.data.rec.docId,
                        invoice_date: this.responseData.data.meta.docDate,
                        invoice_amount: this.responseData.data.rec.docDetail.docAmt,
                        irn: this.responseData.data.rec.docDetail.docIrn,
                        gstin: this.responseData.data.rec.docDetail.docGstin,
                        cmpCode: this.companyCode,
                        purchaseOrg: this.purchaseOrg,
                        erpDocType: this.docType,
                        poNo: this.poNo,
                        username: this.invoiceService.getUsername(),
                        user_id: this.invoiceService.getUserId(),
                        barcodePrefix: this.responseData.data.rec.barcodePrefix,
                        docFormat: "e-invoice",
                      };
                      this.invoiceService.setProcessedInvoice(processedInvoice);
                      this.router.navigate(["/credit-note-preview", this.poNo]);
                    }
                  },
                  (error) => {
                    console.log("E-invoice resubmit error:", error);
                    this.loading = false;
                    this.validateEinvoiceResubmit = false;
                    this.qrCodeError = true;
                    this.message = error.msg;
                  }
                );
              }, 22000);
            }
          } else {
            console.log("Success - E-invoice extracted:", this.responseData);
            this.qrCodeError = false;
            this.poNo = this.route.snapshot.params["poNo"];
            const processedInvoice = {
              file_link: this.responseData.data.meta.src,
              supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
              invoice_number: this.responseData.data.rec.docId,
              invoice_date: this.responseData.data.meta.docDate,
              invoice_amount: this.responseData.data.rec.docDetail.docAmt,
              irn: this.responseData.data.rec.docDetail.docIrn,
              gstin: this.responseData.data.rec.docDetail.docGstin,
              cmpCode: this.companyCode,
              purchaseOrg: this.purchaseOrg,
              erpDocType: this.docType,
              poNo: this.poNo,
              username: this.invoiceService.getUsername(),
              user_id: this.invoiceService.getUserId(),
              barcodePrefix: this.responseData.data.rec.barcodePrefix,
              docFormat: "e-invoice",
            };
            this.invoiceService.setProcessedInvoice(processedInvoice);
            this.router.navigate(["/credit-note-preview", this.poNo]);
          }
        },
        (error) => {
          console.log("E-invoice extraction error:", error);
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = error;
          this.qrCodeError = true;
          this.message = error.msg;
        }
      );
    } else {
      this.validateSignature = true;
      if (this.isPoInvoice) {
        this.invoiceService.setInvoiceType("po_based");
      } else {
        this.invoiceService.setInvoiceType("non_po_based");
      }

      this.invoiceService.setInvType("ds-invoice");

      this.invoiceService.setNoteType(this.creditNoteData.value.noteType);
      const formData: any = new FormData();
      if (localStorage.getItem("selectionType") === "po") {
        formData.append("docNo", this.route.snapshot.params["poNo"] || "");
      }
      formData.append("sellerCode", localStorage.getItem("sellerCode") || localStorage.getItem("vendorCode"));
      formData.append("supplierCode", localStorage.getItem("vendorCode"));
      formData.append("ledger", JSON.stringify(ledger));
      formData.append("invoiceFile", this.creditNoteData.value.fileSource);

      console.log(formData, "formData");

      if (this.creditNoteData.value.noteType === "CN") {
        localStorage.setItem("document", "Credit Note");
      } else {
        localStorage.setItem("document", "Debit Note");
      }

      this.dsLoaderMsg = "Verifying Signature";

      setTimeout(() => {
        this.dsLoaderMsg = "Authenticating Signature";
      }, 5000);
      setTimeout(() => {
        this.dsLoaderMsg = "Extracting Data";
      }, 10000);
      setTimeout(() => {
        this.dsLoaderMsg = "Validating Data";
      }, 15000);

      // Add timestamp for better tracking
      const timestamp = Date.now();

      this.invoiceService.verifyDigitalSignature(formData).subscribe(
        (res) => {
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = res;
          console.log(this.responseData, "this.responseData");

          if (this.responseData.length !== 0 && this.responseData.status === "error") {
            this.loading = true;
            this.signatureError = true;
            this.message = this.responseData.msg;
          } else {
            console.log("Success - Digital signature verified");
            this.qrCodeError = false;
            this.poNo = this.route.snapshot.params["poNo"];
            this.invoiceService.setFileUrl(this.responseData.file_link);
            this.invoiceService.setDataDigitalInvoice(this.responseData.data);

            // Set additional data similar to digital invoice
            const processedInvoice = {
              file_link: this.responseData.data.meta.src,
              supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
              invoice_number: this.responseData.data.rec.docId,
              invoice_date: this.responseData.data.meta.docDate,
              invoice_amount: this.responseData.data.rec.docDetail.docAmt,
              irn: this.responseData.data.rec.docDetail.docIrn,
              gstin: this.responseData.data.rec.docDetail.docGstin,
              cmpCode: convertPods[0].cmpCode,
              purchaseOrg: convertPods[0].purchaseOrg,
              erpDocType: convertPods[0].erpDocType,
              poNo: this.poNo,
              username: this.invoiceService.getUsername(),
              user_id: this.invoiceService.getUserId(),
              barcodePrefix: this.responseData.data.rec.barcodePrefix,
              docFormat: "ds-invoice",
            };
            this.invoiceService.setProcessedInvoice(processedInvoice);
            console.log(processedInvoice, "processedInvoice");
            
            this.router.navigate(["/credit-note-preview-digital-invoice", this.poNo]);
          }
        },
        (error) => {
          console.log("Digital signature verification error:", error);
          this.loading = false;
          this.validateEinvoice = false;
          this.validateSignature = false;
          this.responseData = error;
          this.qrCodeError = true;
          this.message = error.msg;
        }
      );
    }
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["poNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");

    if (localStorage.getItem("selectionType") === "invoice") {
      this.invList = JSON.parse(localStorage.getItem("invoiceList"));
      this.poNo = this.invList[0].poNo;
      if (localStorage.getItem("invoiceType") === "nonPoInvoice") {
        localStorage.setItem("poNo", "");
      } else {
        localStorage.setItem("poNo", this.poNo);
        this.isPoInvoice = true;
      }
    } else {
      this.poNo = this.route.snapshot.params["poNo"];
      localStorage.setItem("poNo", this.poNo);
      this.isPoInvoice = true;
    }

    this.poType = localStorage.getItem("poType");

    if (localStorage.getItem("invoiceType") === "poInvoice") {
      const userData = {
        poNo: this.poNo,
        action: "list",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (this.poResponseData.status == "successful") {
            this.intialLoading = false;
          } else {
            console.log("error");
            this.isService = true;
            this.intialLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.isService = true;
          this.intialLoading = false;
        }
      );
    }

    if (localStorage.getItem("invoiceType") === "poInvoice" || localStorage.getItem("selectionType") === "po") {
      this.fetchPoItems(this.poNo, this.poType);
    } else {
      this.loading = false;
    }
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      // Handle checkbox change if needed
      console.log("Checkbox checked:", e.target.value);
    } else {
      console.log("Checkbox unchecked");
    }
  }
}
